import { render, staticRenderFns } from "./allOrder.vue?vue&type=template&id=f56ba160"
import script from "./allOrder.vue?vue&type=script&lang=js"
export * from "./allOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports